export const useMainLayoutTranslationsESES = () => {
  const esES = {
    menu: {
      profile: 'Perfil',
      accountSettings: 'Configuración de la Cuenta',
      supportMode: 'Entrar en modo de Soporte',
      leaveSupportMode: 'Salir del Modo de Soporte',
    },
    main: {
      api: 'API',
      reports: 'Informes',
      devices: {
        title: 'Dispositivos',
        deviceList: 'Lista de Dispositivos',
      },
      healthCheck: 'Estado de los Dispositivos',
      projections: {
        title: 'Proyecciones',
        dashboard: 'Vista del Panel',
      },
      groups: {
        title: 'Grupos',
        chooseGroup: 'Crear grupos',
      },
      deviceBlocks: 'Gestión de bloqueos',
      tagsManagement: 'Gestión de etiquetas',
      settings: 'Configuración',
    },
    settings: {
      overview: 'Resumen',
      myAccount: 'Mi cuenta',
      loginSecurity: 'Inicio de sesión y Seguridad',
      users: 'Usuarios',
      audit: 'Auditoría',
    },
    developer: {
      title: 'Desarrollador',
      sdk: 'SDK',
      batch: 'Batch',
      credentials: 'Credenciales',
    },
    globalErrorBoundary: {
      title: '¡Ups! Algo salió mal',
      description: 'Ocurrió un error inesperado. Nuestro equipo ha sido notificado.',
      contactSupport: 'Contactar soporte',
      tryAgain: 'Intentar de nuevo',
    },
  };

  return esES;
};
